// Промо-страница стандартизации.
import calculator from "../clean/calculator";
import cleanExamples from "../clean/examples/clean-examples";
import createComponent from "../vue";
import MottoView from "../components/motto";
import modal from "../modal";
import cleanDemo from "../clean/nx-demo/index";
import demoFormToggler from "../components/demo-form/demo-form-toggler";
import cleanUploader from "../clean/uploader/clean-uploader";

const $ = window.jQuery;

$(() => {
    MottoView();
    modal.attach();
});

function initCalculator() {
    calculator.Calculator(document.querySelector(".js-calculator"));
}

function initCleanExamples() {
    createComponent({ components: { cleanExamples } }, "#js-clean-examples");
}

function initCleanDemo() {
    createComponent({
        data() {
            return {
                togglerValue: "form",
                togglerOptions: [
                    {
                        id: "file",
                        text: "В файле",
                        goalName: "CLEAN_DEMO_TOGGLER_FILE",
                    }, {
                        id: "form",
                        text: "По одной записи",
                        goalName: "CLEAN_DEMO_TOGGLER_FORM",
                    },
                ],
            };
        },
        components: {
            cleanDemo,
            cleanUploader,
            demoFormToggler,
        },
    }, "#demo-vue-app");
}

initCalculator();
initCleanExamples();
initCleanDemo();

export default {};
